import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5bfcf1c0"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfcf1c0')) {
      api.createRecord('5bfcf1c0', component.options)
    } else {
      api.reload('5bfcf1c0', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5bfcf1c0", function () {
      api.rerender('5bfcf1c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/icon/Index.vue"
export default component.exports